import { PnetService } from '@previnet/service';
import { PnetLoadingService } from '@previnet/vue-loading';

export default class BaseService extends PnetService {
  public constructor() {
    super({
      redirectUrl: '#/login',
      loadingService: {name: 'loader', instance: PnetLoadingService}
    });
  }

  public async handleJSONResponse(response: Response): Promise<any> {
    if (response.headers.get("content-type") === null ||
    	  response.headers.get("content-type") === 'application/pdf' ||
        response.headers.get("content-type") === 'application/csv') {
      return !response.ok ? rejectPromise(response) : resolvePromise(response);
    }

    const fn = (!response.ok)?(rejectPromise):(dateISO2DateObjectConverter);
    return response.json().then(fn);
  }

  public parseData(data: any): any {
    return dateISO2DateObjectConverter(data);
  }
}

function dateISO2DateObjectConverter(data: any): any {
  const dateISORegExp = /("(?:\d{4})-(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2\d|3[0-1])(?:T(?:0\d|1\d|2[0-3]):(?:[0-5]\d)(?::(?:[0-5]\d))?(?:\.\d{3}Z)?)?")/g;
  let data2Json = JSON.stringify(data);

  if (dateISORegExp.test(data2Json)) {
    data2Json = data2Json.replace(dateISORegExp, "new Date($1)");
    eval("data = " + data2Json);
  }
  return data;
}

function rejectPromise(result: any): Promise<never> {
  return Promise.reject(result);
}

function resolvePromise(result: any): Promise<any> {
  return Promise.resolve(result);
}